<template>
  <div class="videolist2">
    <sub-title :text="title" />
    <div class="list">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="tojump(item)"
      >
        <div class="cover">
          <viimg :istime="true" :imgurl="item.preview_pic" />
        </div>
        <div class="text between">
          <div class="title">{{ item.title | toEllipsisFilter(10) }}</div>
          <div class="num">{{ item.view_num }}人收看</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
import viimg from "../../videoclaim/componens/viimg";
export default {
  components: {
    viimg,
    subTitle,
  },
  props: {
    title: String,
    list: Array,
  },
  methods: {
    tojump(item) {
      this.$router.push({
        path: "/laws/videoimdet",
        query: {
          videoinId: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.videolist2 {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 24px 20px;
  .list {
    .item {
      margin-top: 28px;
      cursor: pointer;
      .cover {
        width: 274px;
        height: 130px;
      }
      .text {
        margin-top: 13px;
        .title {
          width: 170px;
          font-size: 16px;
          color: #333333;
        }
        .num {
          font-size: 12px;
          color: #999999;
        }
      }

      &:hover {
        .text {
          .title {
            color: #0465ea;
          }
        }
      }
    }
  }
}
</style>